import { combineReducers } from "redux";
import userReducer from './userReducer';
import eventReducer from './eventReducer';
import pageReducer from './pageReducer';
import modalReducer from './modalReducer';
import sidebarReducer from './sidebarReducer';
import eventDetailsReducer from './eventDetailsReducer';
import searchEventReducer from './searchEventReducer';
import tokenReducer from "./tokenReducer";

const rootReducers = combineReducers({
    userReducer,
    eventReducer,
    pageReducer,
    modalReducer,
    sidebarReducer,
    eventDetailsReducer,
    searchEventReducer,
    tokenReducer
});

export default rootReducers